import { render, staticRenderFns } from "./FieldVehicle.vue?vue&type=template&id=c63ab2f0&"
import script from "./FieldVehicle.vue?vue&type=script&lang=js&"
export * from "./FieldVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c63ab2f0')) {
      api.createRecord('c63ab2f0', component.options)
    } else {
      api.reload('c63ab2f0', component.options)
    }
    module.hot.accept("./FieldVehicle.vue?vue&type=template&id=c63ab2f0&", function () {
      api.rerender('c63ab2f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldVehicle.vue"
export default component.exports